import React, { useState } from "react";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";
import ToolsApi from "../../../api/ToolsApi";
import MtiButton from "../../Buttons/MtiButton";
import DiagnosticTable from "./DiagnosticTable";
import "./ToolsGeneral.css";

export enum EDiagnosticType {
  MOTOR_ONLY,
  FULL,
}

type Props = {
  style?: React.CSSProperties;
};

export default function Diagnostic({ style }: Props) {
  const [diagnosticType, setDiagnosticType] = useState(
    EDiagnosticType.MOTOR_ONLY
  );

  const runDiagnostic = () => {
    switch (diagnosticType) {
      case EDiagnosticType.MOTOR_ONLY:
        ToolsApi.runMotorDiagnostic();
        break;
      case EDiagnosticType.FULL:
        ToolsApi.runFullDiagnostic();
    }
  };

  const diagnosticDisplayValues = [
    {
      display: "Motor Diagnostics Only",
      value: EDiagnosticType.MOTOR_ONLY,
      disabled: false,
    },
    {
      display: "Full Diagnostics",
      value: EDiagnosticType.FULL,
      disabled: false,
    },
  ];

  return (
    <div className="tools-diagnostic" style={style}>
      <div className="tools-diagnostic-title">Diagnostic</div>
      <div className="tools-diagnostic-action">
        <div className="tools-diagnostic-option">Diagnostic Option</div>
        <CommonDropDown
          id={"diagnostic-type-dropdown"}
          dropDownDisplayValues={diagnosticDisplayValues}
          onChange={(type: number) => {
            setDiagnosticType(type);
          }}
          value={diagnosticType}
          style={{
            minWidth: 253,
          }}
        />
        <MtiButton
          variant="primary"
          colorVariant="black"
          onClick={runDiagnostic}
          style={{
            height: 34,
            paddingLeft: 30,
            paddingRight: 30,
          }}
        >
          RUN
        </MtiButton>
      </div>
      <DiagnosticTable />
    </div>
  );
}
